import InputsTab from "./InputsTab";

export default InputsTab;